<div
  class="border-grey-3 py-xs pl-sm pr-xs paragraph-large-medium gap-xs flex justify-between rounded-lg border bg-white"
>
  @if (competence.estValidee) {
    <span class="content-center" tabindex="0">{{ competence.libelle }}</span>
  } @else {
    <textarea
      class="placeholder:text-text-primary w-full"
      #textAreaCompetence
      [(ngModel)]="competence.libelle"
      placeholder="Veuillez renseigner la compétence"
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
    ></textarea>
  }
  <div class="gap-xxs flex">
    @if (canEdit()) {
      <button
        [hlmTooltipTrigger]="competence.estValidee ? 'Modifier la compétence' : 'Valider la compétence'"
        [attr.aria-label]="competence.estValidee ? 'Modifier la compétence' : 'Valider la compétence'"
        (click)="toggleValidation()"
        type="button"
        hlmBtn
        variant="ghost"
        size="icon"
      >
        @if (competence.estValidee) {
          <ng-icon name="lucidePen" />
        } @else {
          <ng-icon name="lucideCheck" />
        }
      </button>
      @if (!competence.estValidee) {
        <button
          (click)="cancel()"
          aria-label="Annuler la modification"
          hlmTooltipTrigger="Annuler la modification"
          type="button"
          hlmBtn
          variant="ghost"
          size="icon"
        >
          <ng-icon name="lucideX" />
        </button>
        <button
          (click)="delete()"
          aria-label="Supprimer la compétence"
          hlmBtn
          variant="ghost"
          size="icon"
          hlmTooltipTrigger="Supprimer la compétence"
        >
          <ng-icon name="lucideTrash" />
        </button>
      }
    }
  </div>
</div>
